import { mapState } from "vuex";
import FilterLayout from "../../../components/layouts/FilterLayout";
import { convertObjectToParams, downloadFile, scaleScreen } from "../../../components/commons/commons";
import moment from "moment";
import http from "../../../store/modules/helpers/httpInterceptor";
export default {
  name: "TMSReport",
  components: {
    FilterLayout,
  },
  props: {
    msg: String,
  },
  data() {
    return {
      dataSource: [],
      page: "",
      currentPage: "TMS-report",

      sort: {},
      current: 1,
      pageSize: 10,
      allTotal: {},
      total_items: 0,
      filters: {
        page: 1,
        size: 10,
      },
      finalColumns: [],
      columns: [
        {
          title: "Staff",
          fixed: "left",
          dataIndex: "staff",
          key: "staff",
          width: 200,
          scopedSlots: { customRender: "name" },
          // sorter: true
        },
        {
          title: "Effective Date",
          dataIndex: "onboard_date",
          key: "startDate",
          scopedSlots: { customRender: "date" },
        },
        {
          title: "Contract Type",
          dataIndex: "contract_type",
          key: "contractType",
        },
        {
          title: "Contract Start Date ",
          dataIndex: "contract_start_date",
          key: "contractStartDate",
          scopedSlots: { customRender: "date" },
        },
        {
          title: "Contract End Date",
          dataIndex: "contract_end_date",
          key: "contractEndDate",
          scopedSlots: { customRender: "date" },
        },
        {
          title: "Time In Position",
          dataIndex: "time_in_position",
          key: "timeInPosition",
        },
        {
          title: "From Date",
          dataIndex: "start_date",
          key: "salaryStartDate",
          scopedSlots: { customRender: "date" },
        },
        {
          title: "To Date",
          dataIndex: "end_date",
          key: "salaryEndDate",
          scopedSlots: { customRender: "date" },
        },
        {
          title: "Standard Working Days",
          dataIndex: "standard_working_days",
          key: "standardWorkingDay",
        },
        {
          title: "Total Working Days",
          dataIndex: "total_working_days",
          key: "total_working_days",
        },
        {
          title: "Total Onsite Days",
          dataIndex: "total_onsite_days",
          key: "onsiteDays",
        },
        {
          title: "Total Actual Working Days",
          dataIndex: "total_actual_working_days",
          key: "total_actual_working_days",
        },
        {
          title: "Total paid leave days",
          dataIndex: "total_paid_leaving_days",
          key: "paidLeaveDays",
        },
        // {
        //   title: "Birthday leave",
        //   dataIndex: "birthday_leaving",
        //   key: "birthdayDays",
        // },
        {
          title: "Total public holidays",
          dataIndex: "total_public_holidays",
          key: "publicHolidays",
        },
        {
          title: "Total offset leave days ",
          dataIndex: "total_offset_leaving_days",
          key: "offsetLeaveDay",
        },
        {
          title: "Total Paid Leave - Other",
          dataIndex: "total_paid_benefit_leaving_days",
          key: "personalLeaveDayWithSalary",
        },
        {
          title: "Total paid days",
          dataIndex: "total_paid_days",
          key: "totalPaidDays",
        },
        {
          title: "Total days off that social insurance covers",
          dataIndex: "total_si_cover_leaving_days",
          key: "daysOffSocialInsuranceCover",
        },
        {
          title: "No salary",
          dataIndex: "total_unpaid_benefit_leaving_days",
          key: "total_unpaid_benefit_leaving_days",
        },
        {
          title: "Số ngày nghỉ không lương khác",
          dataIndex: "total_unpaid_leaving_days",
          key: "total_unpaid_leaving_days",
        },
        {
          title: "Number Hours of OT in day of Weekday",
          dataIndex: "total_normal_day_overtime_hours",
          key: "total_normal_day_overtime_hours",
        },
        {
          title: "Number Hours of OT in night of Weekday",
          dataIndex: "total_normal_day_night_overtime_hours",
          key: "total_normal_day_night_overtime_hours",
        },
        {
          title: "Number Hours of OT in day of Weekend",
          dataIndex: "total_weekend_overtime_hours",
          key: "total_weekend_overtime_hours",
        },
        {
          title: "Number Hours of OT in night of Weekend",
          dataIndex: "total_weekend_night_overtime_hours",
          key: "total_weekend_night_overtime_hours",
        },
        {
          title: "Number Hours of OT in day of Holidays",
          dataIndex: "total_holiday_overtime_hours",
          key: "total_holiday_overtime_hours",
        },
        {
          title: "Number Hours of OT in night of Holidays",
          dataIndex: "total_holiday_night_overtime_hours",
          key: "total_holiday_night_overtime_hours",
        },
        {
          title: "Original total OT hours",
          dataIndex: "total_overtime_hours",
          key: "total_overtime_hours",
        },
        {
          title: "Final total OT hours",
          dataIndex: "total_exchanged_overtime_hours",
          key: "total_exchanged_overtime_hours",
        },
        {
          title: "Number Hours of OT without Tax",
          dataIndex: "total_without_tax_overtime_hours",
          key: "total_without_tax_overtime_hours",
        },
        {
          title: "Number of Hours Late Coming ",
          dataIndex: "late_coming_hours",
          key: "late_coming_hours",
        },
        {
          title: "Number of Hours Early Leaving ",
          dataIndex: "early_leaving_hours",
          key: "early_leaving_hours",
        },
        {
          title: "Number of Late coming",
          dataIndex: "late_coming_times",
          key: "late_coming_times",
        },
        {
          title: "Number of Early Leaving",
          dataIndex: "early_leaving_times",
          key: "early_leaving_times",
        },
      ],
      checkIOColumns: [
        {
          id: 1,
          title: "Staff",
          dataIndex: "staff",
          key: "staff",
          width: 200,
          scopedSlots: { customRender: "staff" },
          // sorter: true
        },
        {
          id: 2,
          title: "Account",
          dataIndex: "user_name",
          key: "user_name",
        },
        {
          id: 3,
          title: "Department",
          dataIndex: "department",
          key: "department",
        },
        {
          id: 4,
          title: "Date",
          dataIndex: "date_of_issue",
          key: "date_of_issue",
        },
        {
          id: 5,
          title: "Check In",
          dataIndex: "checkin",
          key: "checkin",
        },
        {
          id: 6,
          title: "Check Out",
          dataIndex: "checkout",
          key: "checkout",
        },
        {
          id: 7,
          title: "Late Time",
          dataIndex: "late_time",
          key: "late_time",
        },
        {
          id: 8,
          title: "Leave Early",
          dataIndex: "early_leave",
          key: "early_leave",
        },
        {
          id: 9,
          title: "Absent",
          dataIndex: "absent",
          key: "absent",
          scopedSlots: { customRender: "absent" },
        },
        {
          id: 10,
          title: "Working Day",
          dataIndex: "working_day",
          key: "working_day",
          width: "6%",
        },
      ],
      firstCall: true,
    };
  },
  created() {
    this.scaleScreen();
    if (this.$route.name === "TMS Detail") {
      this.page = "Payroll Report Detail";
      this.currentPage = "detail-TMS-report";
    } else if (this.$route.name === "TMS Summary") {
      this.page = "Payroll Report Summary";
      this.currentPage = "summary-TMS-report";
    } else {
      this.page = "Check In - Check Out Report";
      this.currentPage = "checkInOut-TMS-report";
    }
    this.filters = { ...this.filters, ...JSON.parse(sessionStorage.getItem(this.page)) };
    this.firstCall = true;
  },
  mounted() {
    this.myFunction();
  },
  methods: {
    scaleScreen,
    // onChangeTable(pagination, filters, sorter){
    //   if(sorter.order === 'descend'){
    //     this.sort.direction = 'desc'
    //   }else {
    //     this.sort.direction = 'asc'
    //   }
    //   if (sorter.field === 'staff'){
    //     this.sort.field = 'name'
    //   }else {
    //     this.sort.field = sorter.field
    //   }
    //   this.getData()
    // },
    formatDate(date) {
      if (date) return moment(date).format("DD/MM/YYYY");
      else return "";
    },

    formatHour(date) {
      if (date) return moment(date).format("HH:mm");
      else return "";
    },

    onSetDataFilters(filters) {
      this.filters = filters;
    },

    onApplyFilters(filters) {
      this.filters = filters;
      this.current = 1;
      this.getData();
    },
    // getCurrentPage() {
    //    let queryStr = this.$route.query;
    //    if(queryStr.currentPage) this.currentPage = queryStr.currentPage;
    // },
    checkItem(data) {
      return data ? data : "";
    },
    checkReasonTypeAndDepartment(item) {
      if (item.reason_type && item.reason_type.length) {
        item.reason_type.forEach((requestTypeElement) => {
          this.RequestType.forEach((element) => {
            if (element.sf4c_registration_type === requestTypeElement.RequestType) {
              item.absent.push(element.sf4c_notation + " - " + this.handleLowerCase(requestTypeElement.RequestStatus));
            }
          });
        });
      }
      this.Department.forEach((departmentElement) => {
        if (departmentElement.department_code === item.department) {
          item.department = departmentElement.name_en;
        }
      });
    },
    checkResData(res, count, currentPage, tableColumns) {
      let data = [];
      if (res.data && currentPage === "checkInOut-TMS-report") {
        data = res.data.map((item) => {
          if (item.timesheet_detail && item.timesheet_detail.requests) {
            let arr = [];
            for (const el of item.timesheet_detail.requests) {
              let str = el.request_type + " - " + el.request_status;
              arr.push(str);
            }
            item.absent = arr.toString();
          }
          item.date_of_issue = item.date_of_issue ? this.formatDate(item.date_of_issue) : "";
          item.account = this.checkItem(item.user_name);
          item.checkin = item.timesheet_detail ? this.formatHour(item.timesheet_detail.check_in_time) : "";
          item.checkout = item.timesheet_detail ? this.formatHour(item.timesheet_detail.check_out_time) : "";
          item.late_time = this.checkItem(item.late_time);
          item.early_leave = this.checkItem(item.early_leave);
          item.working_day = this.checkItem(item.working_days);
          this.checkReasonTypeAndDepartment(item);
          return item;
        });
        this.total_items = res.page.total_element;
      } else {
        if (res.data) {
          res.data.request_counting_headers.forEach((element, index) => {
            let temp_column = {};
            temp_column.title = element;
            temp_column.dataIndex = index;
            temp_column.key = index;
            tableColumns.splice(count + index, 0, temp_column);
          });
          data = res.data.report_list;
          data.forEach((element) => (element.id = Math.random()));
          data.forEach((reportElement) => {
            reportElement.request_count_list.forEach((countList, indexCount) => {
              reportElement[indexCount] = countList.value;
            });
          });
          this.total_items = res.page.total_element;
        }
      }
      return data;
    },
    callApi(currentPage, commit, url, tableColumns, param) {
      this.$store
        .dispatch(commit, url)
        .then((res) => {
          let count = 15;
          let data = [];
          if (res) {
            data = this.checkResData(res, count, currentPage, tableColumns);
            this.finalColumns = tableColumns;
            this.dataSource = data;
            this.dataSource.param = param;
            this.firstCall = false;
            this.$store.dispatch("user/loadingRequest");
          } else if (res.message !== null && res.message !== "") {
            if (this.currentPage !== "checkInOut-TMS-report" && res.message !== "Invalid Date!") {
              this.$message.error(res.message, 5);
            }
            this.$store.dispatch("user/loadingRequest");
          } else {
            this.$store.dispatch("user/loadingRequest");
          }
        })
        .catch((error) => {
          this.$message.error(error.message, 5);
          this.$store.dispatch("user/loadingRequest");
        });
    },
    getData() {
      this.$store.dispatch("user/loadingRequest");
      const { pageSize, current, filters, currentPage, sort } = this;
      let param = {};
      if (this.firstCall) {
        param = { ...filters, ...sort };
        this.current = filters.page ? filters.page : 1;
        this.pageSize = filters.size ? filters.size : 10;
      } else {
        param = { ...filters, ...sort, page: current, size: pageSize };
      }
      let tableColumns = [...this.columns];
      let url = "";
      let commit = "";
      if (currentPage === "detail-TMS-report") {
        commit = "report/getDataReportDetail";
        url = convertObjectToParams(param);
      } else if (currentPage === "summary-TMS-report") {
        commit = "report/getDataReportSummary";
        url = convertObjectToParams(param);
      } else if (currentPage === "checkInOut-TMS-report") {
        commit = "report/getDataCheckIOReport";
        url = convertObjectToParams(param, "checkInOut-TMS-report");
        tableColumns = [...this.checkIOColumns];

        this.$store
          .dispatch("application/getReasonRequestList")
          .then((responeRequestType) => {
            if (responeRequestType) {
              return responeRequestType;
            }
          })
          .catch((error) => {
            this.$message.error(error.message, 5);
          });

        this.$store
          .dispatch("application/getDepartmentList")
          .then((responseDepartment) => {
            if (responseDepartment) return responseDepartment;
          })
          .catch((error) => {
            this.$message.error(error.message, 5);
          });
      }
      this.callApi(currentPage, commit, url, tableColumns, param);
      sessionStorage.setItem(this.page, JSON.stringify(param));
    },

    onChangePage(page, size) {
      this.current = page;
      this.pageSize = size;
      this.getData();
    },

    onExport() {
      let param = this.dataSource.param;
      let payload = {
        download: "download",
        url: convertObjectToParams(param),
        name: this.currentPage,
      };
      this.Period.forEach((element) => {
        if (element.timesheet_id === this.filters.timesheetId) {
          payload = {
            ...payload,
            fromDate: moment(element.from_date).format("MM/YYYY"),
            toDate: moment(element.to_date).format("MM/YYYY"),
          };
        }
      });
      if (this.currentPage === "checkInOut-TMS-report") {
        payload.download = "report-check-time";
        payload = {
          ...payload,
          fromDate: this.formatDate(this.filters.fromDate),
          toDate: this.formatDate(this.filters.toDate),
        };
        payload.url = convertObjectToParams(param, "checkInOut-TMS-report");
      } else if (this.currentPage !== "detail-TMS-report") {
        payload.download = "download-summary";
      } else {
        payload.download = "download";
      }
      this.$store.dispatch("user/loadingRequest");
      this.exportReport(payload);
    },

    exportReport(payload) {
      http
        .get(`tms/excel/${payload.download}` + payload.url, { responseType: "blob" })
        .then((res) => {
          if (res.status === 200 && res.data.type !== "application/json") {
            downloadFile(res.data, payload.name + " (" + payload.fromDate + " to " + payload.toDate + ")" + ".xlsx");
            this.$store.dispatch("user/loadingRequest");
            this.$message.success("Report was exported successfully!", 5);
          } else {
            this.$store.dispatch("user/loadingRequest");
            this.$message.error("No data has been exported");
          }
        })
        .catch((err) => {
          this.$store.dispatch("user/loadingRequest");
          this.$message.error(err.message, 5);
        });
    },

    myFunction() {
      document.body.style.position = "absolute";
    },

    handleLowerCase(string) {
      return string.charAt(0) + string.slice(1).toLowerCase();
    },
    //download-detail?timesheetId=5f9bdec28e3ea0ccf3771701&page=1&size=10
  },

  computed: {
    ...mapState({
      DataReportDetail: (state) => state.report.DataReportDetail,
      userInfo: (state) => state.user.userInfo,
      ExportReport: (state) => state.report.ExportReport,
      Period: (state) => state.application.payrollPeiodList,
      RequestType: (state) => state.application.reasonRequestList,
      Department: (state) => state.application.departmentList,
    }),
  },
};
